import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DragAndDrop from '../../common/simple/dragAndDrop';
import fileUpload from '../../images/newDesign/fileUpload.svg';
import { UploadItem } from '../archivePage/UploadItem';
import UploadListItem from './UploadListItem';

const FILE_SIZE_LIMIT = 7340032;

const UploadFiles = ({ uploadItem, setUploadItem }) => {
    const { t } = useTranslation();

    const userID = useSelector(state => state.auth.userProfile.userID);

    const inputFile = useRef(null);

    const addFiles = files => {
        const file = files[0];
        const oversized = file.size > FILE_SIZE_LIMIT;
        if (oversized) {
            console.log('File is too big, skipping', file.name);
            return
        }
        setUploadItem(new UploadItem(file, userID));
    }

    const handleFileSelected = e => {
        const files = e.target.files;
        addFiles(files);
        e.target.value = '';
    }

    return (
        <div className='upload-files'>
            <input
                type='file'
                ref={inputFile}
                style={{display: 'none'}}
                multiple={false}
                onChange={handleFileSelected}
            />
            <DragAndDrop handleDrop={e => addFiles(e.dataTransfer.files)}>
                <div className="drag-and-drop-field" onClick={() => inputFile.current.click()}>
                    <img src={fileUpload} />
                    <div className='field-title'>{t('payment_settings.dragAndDrop')}</div>
                </div>
            </DragAndDrop>

            {uploadItem && (<>
                <div className="files-list">
                    <UploadListItem item={uploadItem} />
                </div>
            </>)}
        </div> 
    )
}

export default UploadFiles;